<template>
  <div>
    <page-title>
      {{ $t('fields.create_account') }}
    </page-title>
    <register />
  </div>
</template>

<script>
import Register from '~/marketplace-front-core/components/auth/Register'

export default {
  components: {
    Register
  },
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.$t('register.title'),
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
        ...i18nHead.meta,
        { hid: 'robots', name: 'robots', content: 'noindex, nofollow' }
      ],
      link: [
        ...this.metaLink(i18nHead.link)
      ]
    }
  },
  meta: { auth: 'false' }
}
</script>
